import { Grid, Typography } from 'material-ui'
import * as React from 'react'
import { SFC } from 'react'
import { BlueGreenBar } from '../components/BlueGreenBar'

export const TitleSpread: SFC<{
    img: string
    color: string
    goBack: () => void
}> = ({img, color, goBack, children}) => {

    return (
        <div
            style={{
                height: 700,
                width: '100%',
                background: `${color} url("${img}") no-repeat`,
                backgroundSize: 'cover',
                minHeight: 700
            }}
        >
            <div style={{padding: 20, textAlign: 'left'}}>
                <img
                    src='/img/nav/back.svg'
                    alt='close'
                    onClick={goBack}
                    style={{padding: 10, cursor: 'pointer', height: 30}}
                />

                {children}
            </div>
        </div>
    )

}

export const TitleSpreadContent: SFC<{
    title: string
    extraLargeTitle?: boolean
    sub: string
}> = ({title, sub, extraLargeTitle, children}) => {

    const titleSize = extraLargeTitle ? 96 : 48

    return (
        <Grid container>
            <Grid item xs={12}>
                <Typography type='title' style={{color: '#fff', fontWeight: 300}}>
                    {sub}
                </Typography>
                <Typography
                    type='display4'
                    style={{color: '#fff', fontWeight: 300, marginBottom: 25, fontSize: titleSize}}
                >
                    {title}
                </Typography>
                <Typography
                    type='subheading'
                    style={{
                        color: '#fff',
                        lineHeight: 2,
                        fontSize: 16,
                        fontWeight: 100,
                    }}
                >
                    {children}

                </Typography>
            </Grid>
        </Grid>
    )
}

export const TitleSpreadBody: SFC<{}> = ({children}) => {
    return (
        <div
            style={{
                width: '90%',
                maxWidth: 800,
                margin: '130px auto 20px'
            }}
        >
            {children}
        </div>
    )
}

export const TitleSpreadLinks: SFC<{}> = ({children}) => {
    return (
        <div>
            <div style={{margin: '20px 0'}}>
                <BlueGreenBar fullWidth size={1}/>
            </div>
        </div>
    )
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/stories/TitleSpread.tsx